import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'react-external-link';
import { pushEvent } from '../../../utils/dataLayer';

export default class FooterLinks extends React.Component {

    handleLanguageClick = (language) => {
        console.log(language);
        pushEvent('site_language_changed', { language });
        localStorage.setItem('language', language);
        document.documentElement.lang = language;

        window.location.reload();
    }

    handleOutboundClick = (linkUrl, linkType) => {
        pushEvent('site_outbound_clicked', { link_url: linkUrl, link_type: linkType });
    }

    render() {
        return (
            <div className="bottom">
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12 col-md-10">
                            <span>&copy; 2024 
                                <span language="ar">شركة فورد للسيارات</span>
                                <span language="en">Ford Motor Company</span>
                            </span>
                            <Link
                                className="footer-link mx-2"
                                to="/"
                                onClick={() => this.handleLanguageClick('en')}
                            >
                                <span>English</span>
                            </Link>
                            <Link
                                className="footer-link mx-2"
                                to="/"
                                onClick={() => this.handleLanguageClick('ar')}
                            >
                                <span>عربي</span>
                            </Link>
                            <Link className="footer-link mx-2" to="/country">
                                <span language="ar">اختيار دولة</span>
                                <span language="en">Country Select</span>
                            </Link>
                            <ExternalLink className="footer-link mx-2" href="https://fordlifestylecollection.com/" onClick={() => this.handleOutboundClick('https://fordlifestylecollection.com/', 'merchandise')}>
                                <span language="ar">سلع فورد</span>
                                <span language="en">Ford Merchandise</span>
                            </ExternalLink>
                            {process.env.REACT_APP_WHICH_APP === 'Ford' &&
                                <ExternalLink className="footer-link mx-2" href={process.env.REACT_APP_LINCOLN_ACCESSORIES_URL} onClick={() => this.handleOutboundClick(process.env.REACT_APP_LINCOLN_ACCESSORIES_URL, 'lincoln_accessories')}>
                                    <span language="ar">Lincoln ملحقات</span>
                                    <span language="en">Lincoln Accessories</span>
                                </ExternalLink>
                            }
                            {process.env.REACT_APP_WHICH_APP === 'Lincoln' &&
                                <ExternalLink className="footer-link mx-2" href={process.env.REACT_APP_FORD_ACCESSORIES_URL} onClick={() => this.handleOutboundClick(process.env.REACT_APP_FORD_ACCESSORIES_URL, 'ford_accessories')}>
                                    <span language="ar">Ford ملحقات</span>
                                    <span language="en">Ford Accessories</span>
                                </ExternalLink>
                            }
                            <ExternalLink className="footer-link mx-2" href="https://www.me.ford.com/en/qat/privacy-policy/" onClick={() => this.handleOutboundClick('https://www.me.ford.com/en/qat/privacy-policy/', 'privacy')}>
                                <span language="ar">الخصوصية وبيان إخلاء المسؤولية</span>
                                <span language="en">Privacy & Disclaimer</span>
                            </ExternalLink>
                            {process.env.REACT_APP_WHICH_APP === 'Ford' &&
                                <ExternalLink className="footer-link mx-2" href="https://www.me.ford.com/" onClick={() => this.handleOutboundClick('https://www.me.ford.com/', 'brand_home')}>
                                    <span language="ar">فورد الشرق الأوسط</span>
                                    <span language="en">Ford Middle East</span>
                                </ExternalLink>
                            }
                            {process.env.REACT_APP_WHICH_APP === 'Lincoln' &&
                                <ExternalLink className="footer-link mx-2" href="https://www.me.lincoln.com/" onClick={() => this.handleOutboundClick('https://www.me.lincoln.com/', 'brand_home')}>
                                    <span language="ar">لينكولن الشرق الأوسط</span>
                                    <span language="en">Lincoln Middle East</span>
                                </ExternalLink>
                            }
                        </div>
                        <div className="col-xs-12 col-md-2 text-end">
                            <ExternalLink href={process.env.REACT_APP_WEBSITE_LINK} onClick={() => this.handleOutboundClick(process.env.REACT_APP_WEBSITE_LINK, 'website')}>
                                <img src={'/images/' + process.env.REACT_APP_WHICH_APP.toLowerCase() + '.svg'} alt={process.env.REACT_APP_WHICH_APP} />
                            </ExternalLink>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
